module.exports = __webpack_public_path__ + "static/media/TH.6b24e5ee.svg";